import { render, staticRenderFns } from "./EscogerGrupos.vue?vue&type=template&id=115a7b54&scoped=true&"
import script from "./EscogerGrupos.vue?vue&type=script&lang=js&"
export * from "./EscogerGrupos.vue?vue&type=script&lang=js&"
import style0 from "./EscogerGrupos.vue?vue&type=style&index=0&id=115a7b54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a7b54",
  null
  
)

export default component.exports